import { faEllipsis, faTag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
//import Avatar from 'components/base/Avatar';
import Button from 'components/base/Button';
import IndeterminateCheckbox from 'components/base/IndeterminateCheckbox';
import StarCheckbox from 'components/base/StarCheckbox';
import { MediaModel } from 'data/media';
//import { getFileIcon } from 'helpers/utils';
import { useBulkSelect } from 'providers/BulkSelectProvider';
import { Col, Dropdown, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface MediaRowProps {
  media: MediaModel;
  index: number;
}

const MediaRow = ({ media, index }: MediaRowProps) => {
  const { getRowCheckboxProps } = useBulkSelect();
  return (
    <div className="border-bottom hover-actions-trigger py-3">
      <Row className="gx-2">
        <Col xs="auto">
          <div className="d-flex flex-column flex-sm-row">
            <IndeterminateCheckbox
              {...getRowCheckboxProps(String(index))}
              className="mb-2 m-sm-0 me-sm-2"
            />
            <Button className="btn p-0">
              <StarCheckbox defaultChecked={media.starred} iconClass="fs-9" />
            </Button>
          </div>
        </Col>
        <Col className="col-auto">
          <Link
            to="#!"
            className={classNames('fs-9 inbox-link', {
              'text-900 fw-semi-bold': media.name,
              'text-1100 fw-bold': !media.name
            })}
          >
            {String(media.name)}
          </Link>
        </Col>
        <Col className="col-auto ms-auto">
          <div className="hover-actions end-0">
            <Dropdown>
              <Dropdown.Toggle
                variant="phoenix-secondary"
                className="dropdown-caret-none btn-icon"
              >
                <FontAwesomeIcon icon={faEllipsis} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="#!">Use this</Dropdown.Item>
                <Dropdown.Item href="#!">Star</Dropdown.Item>
                <Dropdown.Item href="#!">Archive</Dropdown.Item>
                <Dropdown.Item href="#!">Download</Dropdown.Item>
                <Dropdown.Item href="#!">Print</Dropdown.Item>
                <Dropdown.Item href="#!">Report</Dropdown.Item>
                <Dropdown.Item href="#!" className="text-danger">
                  Delete
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <span
            className={classNames('fs-10', {
              'fw-bold': media.createdDate
            })}
          >
            Created Date:{' '}
            {media.createdDate
              ? new Date(media.createdDate).toLocaleDateString('en-GB')
              : ''}
          </span>
        </Col>
      </Row>
      <div className="ms-4 mt-n3 mt-sm-0">
        <Link to="/apps/email/email-detail" className="d-block inbox-link">
          {/* <span
            className={classNames('fs-9 line-clamp-1', {
              'text-1000': email.read_at,
              'text-1100': !email.read_at
            })}
          > 
            {email.subject}
          </span>*/}
          <img src={media.url} className="mt-2" alt="..." />
        </Link>

        {media.tags?.map(tag => (
          <a
            href="#!"
            className="d-inline-flex align-items-center border rounded-pill px-3 py-1 me-2 mt-2 inbox-link"
            key={tag}
          >
            <FontAwesomeIcon icon={faTag} className="text-primary" />
            <span className="ms-2 fw-bold fs-10 text-900">{tag}</span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default MediaRow;
